import { getRefreshToken, getToken } from 'app/shared/util/token-utils';
import axios, { AxiosResponse } from 'axios';
import { GlobalConfDTO } from '../service/dtos/GlobalConfDTO';

export interface IGlobalApi {
  getGlobalConfig(): Promise<AxiosResponse<GlobalConfDTO>>;
  getSellingPoints(name: string): Promise<AxiosResponse<any>>;
}

export class GlobalApi implements IGlobalApi {
  async getGlobalConfig(): Promise<AxiosResponse<GlobalConfDTO>> {
    return axios.get('api/global/');
  }

  async getSellingPoints(name: string): Promise<AxiosResponse<any>> {
    return axios.post(`/api/sellingPoint/findByName/${name}`);
  }
}
